var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuitPip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 45.5H21.6693C13.4983 45.5 9.41275 45.5 6.87435 42.9616C4.33594 40.4232 4.33594 36.3377 4.33594 28.1667V23.8333C4.33594 15.6623 4.33594 11.5768 6.87435 9.03841C9.41275 6.5 13.4983 6.5 21.6693 6.5H30.3359C38.5069 6.5 42.5924 6.5 45.1309 9.03841C47.6693 11.5768 47.6693 15.6623 47.6693 23.8333",
    stroke: "#513117",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1641 36.8327C28.1641 32.7472 28.1641 30.7044 29.4333 29.4352C30.7025 28.166 32.7452 28.166 36.8307 28.166H38.9974C43.0829 28.166 45.1257 28.166 46.3949 29.4352C47.6641 30.7044 47.6641 32.7472 47.6641 36.8327C47.6641 40.9182 47.6641 42.9609 46.3949 44.2301C45.1257 45.4993 43.0829 45.4993 38.9974 45.4993H36.8307C32.7452 45.4993 30.7025 45.4993 29.4333 44.2301C28.1641 42.9609 28.1641 40.9182 28.1641 36.8327Z",
    stroke: "#513117",
    strokeWidth: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2474 16.2493V22.7493M16.2474 16.2493H22.7474M16.2474 16.2493L24.9141 24.916",
    stroke: "#513117",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuitPip);
export default __webpack_public_path__ + "static/media/quit-pip.0262ab90f2d34f63eec6e5bc39dee402.svg";
export { ForwardRef as ReactComponent };